"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./FooterStepper.css");

var _styles = {
  "footer-stepper": "FooterStepper__footer-stepper___f8IqC",
  "hidden": "FooterStepper__hidden___3gyHA",
  "actions": "FooterStepper__actions___3VrCv",
  "back-button": "FooterStepper__back-button___3sVAH",
  "next-button": "FooterStepper__next-button___1SG4w",
  "next-wrapper": "FooterStepper__next-wrapper___2A27f"
};

const styles = _bind.default.bind(_styles);

const FooterStepper = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  currentStep,
  totalSteps,
  hideStepInfo,
  backButtonLabel = 'Back',
  nextButtonLabel = 'Continue',
  backButtonEnabled = true,
  nextButtonEnabled = true,
  onBackClick,
  onNextClick
}) => {
  const composed_classname = (0, _bind.default)(styles('footer-stepper'), className);
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composed_classname
  }, _react.default.createElement(_.ProgressBar, {
    dataTestId: dataTestId && `${dataTestId}-progress-bar`,
    variant: 'line-lime',
    progress: currentStep / totalSteps
  }), _react.default.createElement("div", {
    className: styles('actions')
  }, _react.default.createElement(_.Button, {
    className: styles('back-button', {
      hidden: currentStep <= 1
    }),
    disabled: backButtonEnabled === false || currentStep <= 1,
    variant: 'outlined',
    label: backButtonLabel,
    onClick: onBackClick || (() => undefined),
    dataTestId: dataTestId && `${dataTestId}-back-button`
  }), hideStepInfo || currentStep < 1 ? _react.default.createElement("div", null) : _react.default.createElement(_.Text, {
    dataTestId: dataTestId && `${dataTestId}-step-info`,
    text: `Step ${currentStep} of ${totalSteps}`
  }), _react.default.createElement(_.Button, {
    className: styles('next-button'),
    disabled: nextButtonEnabled === false,
    label: nextButtonLabel,
    flexAlignSelf: 'flex-start',
    onClick: onNextClick || (() => undefined),
    dataTestId: dataTestId && `${dataTestId}-next-button`
  })));
});
var _default = FooterStepper;
exports.default = _default;